<template>
	<el-container>
		<el-main class="mainWrap">
			<Header></Header>
			<div class="wrap">
				<div class="title">《用户协议》</div>
				<div class="content">
					<div>本《用户注册协议》是您（以下亦称“用户”）与杭州飞长好旅游有限公司之间缔结的，在您使用我们（以下提及“我们”时，亦包括我们的关联方或我们指定的合作方）出品或运营的软件产品和网络服务（以下合称“飞长好”）的某些功能之前，为注册飞长好与服务相关账号（以下统称“飞长好账号”）而签署的有法律约束力的协议。</div>
					<div class="subTitle">1. 重要须知——在签署本协议之前，我们严正提醒用户</div>
					<div>1.1. <span class="blodline">您应认真阅读（若您为未成年人，应当在监护人陪同下阅读）并充分理解本《用户注册协议》中的各项条款，包括免除或者限制我们的责任的条款、用户的权利进行限制的条款，以及约定适用法律和争议管辖的条款。</span>如您对本协议条款有任何疑问，可以向客服人员咨询。</div>
					<div>1.2. 除非您接受本协议，否则用户无权也不应接受针对注册用户提供的飞长好产品与服务，您可以退出本次注册。<span class="blodline">用户点击“同意并注册账号”、“接受”等含义的按钮，或实际使用我们针对注册用户提供的服务，视为用户已完全接受并签署本协议。</span></div>
					<div>1.3. 本协议一经签署，具有法律效力，请您慎重考虑是否接受本协议。</div>
					<div>1.4. <span class="blodline">在您签署本协议之后，本协议文本可能因法律法规、国家政策、产品功能和形态、运营方案以及履行本协议的环境发生变化而进行修改。</span>修改后的协议发布在本网站／软件上，您可随时查看</div>
					<div>1.5. <span class="blodline">我们的服务范围非常广泛，因此有时还会适用一些附加条款或产品要求（包括年龄要求）。附加条款将会与相关服务一同提供，并且在您使用这些服务后，成为您与我们所达成的协议的一部分。</span></div>
					<div>1.6. <span class="blodline">若您是未成年人，您应当请您的监护人仔细阅读本协议，并在征得您的监护人同意的前提下使用飞长好产品与服务或向我们提供信息。</span></div>
					<div class="subTitle">2. 关于“飞长好帐号”</div>
					<div>2.1. 我们通过各项飞长好产品与服务，同时提供用户注册通道。无论用户通过哪一通道注册并接受本协议，本协议均适用于全部飞长好产品与服务，具有同等法律效力。 </div>
					<div>2.2. 用户在接受本协议之后，有权选择系统允许的且未被其他用户使用的字符组合作为用户的飞长好账号名称，并自行设置符合安全要求的密码。用户设置的账号名称和密码是用户用以登录及使用飞长好产品与服务，以及持有金豆等虚拟货币和虚拟物品的凭证。</div>
					<div>2.3. 用户在注册飞长好账号成功之后，我们会按系统规则自动分配给用户一个飞长好号码，号码与飞长好账号名称同样是用户登录及使用飞长好产品与服务的身份识别凭证。</div>
					<div>2.4. 飞长好账号的法律性质是我们允许用户使用特定产品与服务而授予用户的凭证。飞长好账号是我们相应计算机软件作品和网络服务的一部分，是我们将相应的计算机软件作品和网络服务授权给注册用户使用的授权凭证。</div>
					<div>2.5. 飞长好账号同时还承载着用户的使用数据与信息，是用户持有、使用相关虚拟货币、虚拟道具的凭证。用户若需要接受我们提供的增值服务，飞长好账号同时也是用户支付费用、接受增值服务的凭证。</div>
					<div>2.6. 用户注册了飞长好账号并不意味已获得全部飞长好产品与服务的授权。用户在登录相关网页、加载应用、下载及安装软件时可能需要另行签署单个产品的授权协议。</div>
					<div>2.7. 按照法律、政策和／或我们的平台规则和公告（定义见后文）要求，注册用户须配合完成身份信息实名认证。</div>
					<div>2.8. 用户应当妥善保管自己的飞长好账号及密码，不应向任何其他人透露密码。<span class="blodline">用户飞长好账号项下一切活动均视为用户本人的行为，用户就该等活动负全部责任，因该等活动而形成的用户数据的修改，虚拟货币及虚拟道具的损失以及其他所有的损失均由用户自行承担。</span>用户须重视飞长好账号密码保护。用户如发现他人未经许可使用其账号时应当立即通知我们。</div>
					<div>2.9. 用户飞长好账号在丢失或遗忘密码后，可遵照我们的申诉途径及时申诉请求找回账号。用户应不断提供能增加账号安全性的个人密码保护资料。用户可以凭初始注册资料及个人密码保护资料填写申诉单向我们申请找回账号，我们的密码找回机制仅负责识别申诉单上所填资料与系统记录资料相比对后是否吻合，而无法识别申诉人是否真正系该YY账号的有权使用人。<span class="blodline">对用户因被他人冒名申诉而导致的任何损失，我们在法律允许范围内不承担任何责任。</span>用户知晓飞长好账号及密码保管责任在于用户，<span class="blodline">我们并不承诺飞长好账号丢失或遗忘密码后用户一定能通过申诉找回账号。</span></div>
					<div>2.10. <span class="blodline">如用户违反法律法规、本协议、各项飞长好产品与服务的独立协议或平台规则和公告等规定，我们有权根据相关规则进行违规判定，并采取相应限制或处罚措施，包括但不限于：限制或冻结用户对飞长好账号的使用，限制或停止某项或多项特定产品、服务或功能等等。</span>当用户的行为同时违反两项（或以上）上述相关规则，且该等规则对违规判定标准或限制／处罚措施规定不一致时，我们有权选择其认为最适当的予以适用。我们有权根据实际情况决定是否以及何时终止上述限制或处罚措施。 </div>
					<div class="subTitle">3. 用户不得从事以下行为：</div>
					<div>3.1. 利用飞长好产品与服务制作、复制、发表、传送、传播、储存含有下列内容的违法或不良信息，包括但不限于设置和使用含有以下内容的飞长好账号名称、昵称、网名、角色名、头像等：</div>
					<div class="ident">1）违背宪法基本原则、危害国家安全、泄露国家秘密、颠覆国家政权、破坏国家统一、影响社会稳定或损害国家荣誉或利益的内容；</div>
					<div class="ident">2）歪曲、丑化、亵渎、否定英雄烈士事迹和精神、侵害英雄烈士，宣扬恐怖主义、极端主义或煽动实施相关活动，煽动民族仇恨、民族歧视，破坏民族团结，破坏国家宗教政策，宣扬邪教和封建迷信，或散布谣言、扰乱经济秩序和社会秩序的内容；</div>
					<div class="ident">3）侮辱、诽谤、色情、赌博、暴力、凶杀、恐怖、教唆犯罪以及其他引起他人不安及任何违反国家法律法规或政策的内容；</div>
					<div class="ident">4）使用夸张标题，内容与标题严重不符的，炒作绯闻、丑闻、劣迹等的，不当评述自然灾害、疫情、重大事故等灾难的，带有性暗示、性挑逗等易使人产生性联想的，展现血腥、惊悚、残忍等致人身心不适的，煽动人群、地域等歧视的，宣扬低俗、庸俗、媚俗内容的，可能引发未成年人模仿不安全行为和违反社会公德行为、诱导未成年人不良嗜好的，以及其他可能对网络生态造成不良影响的内容。</div>
					<div>3.2. 进行任何危害计算机网络安全的行为，包括但不限于：使用未经许可的数据或进入未经许可的服务器／账户；未经允许进入公众计算机网络或者他人计算机系统并删除、修改、增加存储信息；未经许可，企图探查、扫描、测试构成飞长好产品与服务的软件系统／网站／网络的弱点或其它实施破坏网络安全的行为；企图干涉、破坏前述软件系统／网站／网络的正常运行，故意传播恶意程序或病毒以及其他破坏干扰正常网络信息服务的行为；伪造数据包名称或部分名称或者内容；利用深度学习、虚拟现实等新技术新应用从事违法或不道德的活动。</div>
					<div>3.3. 进行任何欺诈性的、破坏飞长好产品与服务公平性或者其他影响飞长好产品与服务正常秩序的行为，如实施流量造假或劫持、虚假注册账号、非法交易账号、批量或自动化操控账号、主动或被动“刷分”、合伙串通作弊、使用外挂或者其他的作弊或修改软件、利用BUG（又叫“漏洞”或者“缺陷”）来获得不正当的非法利益，或者利用互联网或其他方式将外挂、作弊软件、BUG公之于众。</div>
					<div>3.4. 进行其他任何违法（包括但不限于《计算机信息网络国际联网安全保护管理办法》、《互联网信息服务管理办法》、《互联网电子公告服务管理规定》、《维护互联网安全的决定》、《互联网新闻信息服务管理规定》、《中华人民共和国网络安全法》等相关法律法规）、违反监督机关政策或侵犯其他个人、公司、社会团体、组织的合法权益的行为，以及任何违反飞长好产品与服务的独立协议，或者违反平台规则和公告的行为。</div>
					
				</div>
			</div>
			<div class="bottom">
				<Footer></Footer>
			</div>
		</el-main>
	</el-container>
</template>

<script>
	export default {
		data() {
			return {
				
			}
		},
		computed: {
			
		},
		onLoad(option) {
			
		},
		created() {
			
		},
		methods: {
			
		}
	}
</script>
<style lang="scss" scoped>
	.el-main{
		padding: 0 !important;
	}
	.wrap{
		width: 100%;
		padding: 30px;
		box-sizing: border-box;
		.title{
			font-weight: bold;
			font-size: 30px;
			text-align: center;
		}
		.content{
			width: 100%;
			margin-top: 30px;
			>div{
				display: block;
				font-size: 20px;
				line-height: 30px;
				color: #666666;
				margin-top: 6px;
				&.ident {
					text-indent: 1em;
				}
				.blodline {
					font-weight: bold;
					text-decoration: underline;
				}
				&.subTitle{
					font-size: 30px;
					font-weight: bold;
					color: #000000;
					line-height: 60px;
				}
			}
		}
	}
</style>


// WEBPACK FOOTER //
// src/views/service.vue